import { startPageLoader, stopPageLoader } from "@/helpers/page_loader"

interface SearchFlags extends Flags {
  autocomplete: AutocompleteData
  date: { flexibility?: { value?: number } }
  lengthsOfStay: { selected: [string, string] }
  location: { selected?: { name: string } }
  path: { value: string }
}

interface SearchPorts {
  filterCountChanged: PortToElm<number>
  pathChanged: PortToElm<string>
  ready: PortFromElm<SearchFlags>
  search: PortFromElm<string>
  viewportChanged: PortToElm<null>
}

const addTurboFiltersHandlers = (ports?: SearchPorts): void => {
  const onFiltersFrameRender = (): void => {
    const appliedFilterCount = +(
      document.querySelector<HTMLElement>("[data-filter-count]")?.dataset.filterCount || 0
    )

    // Stop spinner on frame render
    stopPageLoader()

    // Turbo filter selections result in URL (and other) changes, so pass those back to the app
    ports?.pathChanged.send(window.location.href.replace(window.location.origin, ""))
    ports?.filterCountChanged.send(appliedFilterCount)
  }

  const isFiltersFrame = (target: EventTarget | null): boolean =>
    !!(target as HTMLElement)?.closest("#turbo-filters-bar, #turbo-filters-modal")

  // Start spinner on fetch request
  document.addEventListener("turbo:before-fetch-request", (e) => {
    if (isFiltersFrame(e.target)) {
      startPageLoader()
    }
  })

  // Handle frame render. Listen on `document` instead of `turbo-frame` so that handler will
  // persist when using back/forward buttons
  document.addEventListener("turbo:frame-render", (e) => {
    if (isFiltersFrame(e.target)) {
      onFiltersFrameRender()
    }
  })

  // Back/forward buttons need to be treated as frame render
  window.addEventListener("popstate", () => {
    // Use zero-delay `setTimeout` to ensure document state is fully ready
    // See https://developer.mozilla.org/en-US/docs/Web/API/Window/popstate_event#sect1
    window.setTimeout(onFiltersFrameRender)
  })
}

export { type SearchFlags, type SearchPorts, addTurboFiltersHandlers }
